module.exports = {
	closeText: 'Close',
	prevText: 'Prev',
	nextText: 'Next',
	currentText: 'Today',
	monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
		'July', 'August', 'September', 'October', 'November', 'December'],
	monthNamesShort: ['jan', 'feb', 'march', 'apr', 'may', 'june',
		'july', 'aug', 'sep', 'oct', 'nov', 'dec'],
	dayNamesShort: ['sun', 'mon', 'tue', 'wed', 'thurs', 'fri', 'sat'],
	dayNames: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
	dayNamesMin: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
	weekHeader: 'W',
	dateFormat: 'dd/mm/yy',
	firstDay: 1,
	isRTL: false,
	showMonthAfterYear: false,
	yearSuffix: ''
};
